import { AllRouteTypes } from 'common/model/AllRouteNames';
import { RoutesType } from 'common/model/RoutesType';
import { Route, Routes } from 'react-router-dom';

export const createLink = (
  prefixEnum: AllRouteTypes,
  link: string,
  branchId?: number | string | null,
) => {
  const normalizedLink = link.startsWith('/') ? link.slice(1) : link;
  const prefix = prefixEnum['PREFIX'] as string;

  if (!prefix || prefix === '/' || prefix === '') {
    return `/${normalizedLink}`;
  }

  const parts = [prefix];
  if (branchId) {
    parts.push(String(branchId));
  }
  parts.push(normalizedLink);

  return '/' + parts.join('/');
};

export const createRoute = (routes: RoutesType[]) => (
  <Routes>
    {routes.map((route, key) => (
      <Route key={key} path={route.path} element={route.element} />
    ))}
  </Routes>
);
